import { EmojiHappyIcon } from "@heroicons/react/outline";
import { PaperAirplaneIcon, XIcon } from "@heroicons/react/solid";
import { Picker } from "emoji-mart";
import _ from "lodash";
import React, { useContext, useEffect, useRef, useState } from "react";
import * as ReactQuill from "react-quill";
import { firebase } from "../constants/firebase";
import { PopupContext } from "../containers/Popup";
import { UserContext } from "../containers/UserProvider";
import { OutsideClickAlerter } from "./OutsideClickAlerter";

export const CreateComment = ({
  isReply,
  commentId,
  subtitle,
  cancelHandler,
  replyId,
  prefilledText = "",
  placeHolder = "Share your thoughts...",
  editMode = false,
  closeEditMode,
}) => {
  const db = firebase.firestore();
  const user = useContext(UserContext);
  const [text, setText] = useState(prefilledText);
  const [modules, setModules] = useState({});
  const editor = useRef(null);
  const [showEmojiMart, setShowEmojiMart] = useState(false);
  const { thread } = useContext(PopupContext);

  const postComment = () => {
    const now = firebase.firestore.Timestamp.fromDate(new Date());

    if (editMode) {
      db.collection("comments")
        .doc(commentId)
        .update({
          text,
          updatedAt: now,
        })
        .then(() => {
          closeEditMode();
        });
    } else {
      db.collection("comments").add({
        createdAt: now,
        updatedAt: now,
        text,
        user: db.doc(`/users/${user.uid}`),
        emojis: [],
        replies: [],
        thread: db.doc(`/threads/${thread}`),
      });
    }
  };

  const postReply = (comId) => {
    const now = firebase.firestore.Timestamp.fromDate(new Date());

    if (editMode) {
      db.collection("replies")
        .doc(replyId)
        .update({
          text,
          updatedAt: now,
        })
        .then(() => {
          closeEditMode();
        });
    } else {
      db.collection("replies")
        .add({
          createdAt: now,
          updatedAt: now,
          text,
          user: db.doc(`/users/${user.uid}`),
          emojis: [],
        })
        .then((replyDoc) => {
          db.collection(`comments`)
            .doc(comId)
            .get()
            .then((doc) => {
              const { replies } = doc.data();
              doc.ref
                .update({
                  replies: [...replies, replyDoc],
                })
                .then(() => {
                  cancelHandler();
                });
            });
        });
    }
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "ordered",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
  ];

  useEffect(() => {
    if (_.isEmpty(modules)) {
      setModules({
        toolbar: {
          container: "#toolbar",
        },
      });
    }
  }, [modules]);

  const addEmoji = (e) => {
    setText(text + e.native);
  };

  return (
    <div className="primary-footer">
      <div className="msg-input">
        <div
          className={`${
            subtitle ? "block" : "hidden"
          } w-full bg-indigo-500 rounded-t-lg py-2 px-4 flex`}
        >
          <p className="flex-none text-gray-200 text-sm">{subtitle}</p>
          <div className="flex-grow"> </div>
          <button
            type="button"
            className="flex-none"
            onClick={() => cancelHandler()}
          >
            {" "}
            <XIcon className="text-gray-200 h-4 w-4" />
          </button>
        </div>
        <div className="relative w-full">
          {showEmojiMart && (
            <OutsideClickAlerter handler={() => setShowEmojiMart(false)}>
              <Picker
                style={{
                  position: "absolute",
                  left: "5%",
                  top: "-50%",
                  zIndex: 9999,
                }}
                emojiTooltip
                set="apple"
                onSelect={addEmoji}
                title=""
                autoFocus
                // theme="dark"
              />
            </OutsideClickAlerter>
          )}
        </div>{" "}
        <div
          className={`bg-gray-700 bg-opacity-100 rounded${
            subtitle ? "-b-" : "-"
          }lg`}
        >
          <form>
            <ReactQuill
              value={text}
              onChange={(html) => setText(html)}
              theme={null}
              ref={editor}
              modules={modules}
              formats={formats}
              placeholder={placeHolder}
            />
            <div id="toolbar" className="flex py-2 px-2">
              <button
                type="button"
                className="ql-bold w-8 h-8 text-center mr-2 flex-none hover:bg-gray-500 py-1 rounded flex items-center font-semibold justify-center"
              >
                B
              </button>
              <button
                type="button"
                className="ql-italic italic w-8 h-8 justify-center px-2 mr-2 flex-none hover:bg-gray-500  py-1 rounded flex items-center font-semibold"
              >
                I
              </button>
              <button
                type="button"
                value="bullet"
                className="ql-list w-8 h-8 justify-center px-2 mr-2 flex-none hover:bg-gray-500  py-1 rounded flex items-center font-semibold"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 0 24 24"
                  width="24px"
                  fill="#FFFFFF"
                >
                  <path d="M0 0h24v24H0V0z" fill="none" />
                  <path d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z" />
                </svg>
              </button>
              <div className="flex-grow"> </div>
              <button
                type="button"
                className="w-8 h-8 justify-center px-2 mr-2 flex-none hover:bg-gray-500  py-1 rounded flex items-center font-semibold"
                onClick={(e) => setShowEmojiMart(true)}
              >
                <EmojiHappyIcon className="text-white" />
              </button>
              <button
                onClick={() => (isReply ? postReply(commentId) : postComment())}
                type="button"
                className="bg-blue-500 hover:bg-blue-400 px-3 py-1 rounded flex items-center font-semibold"
              >
                {editMode ? "Update " : "Post "}
                <PaperAirplaneIcon className="ml-2 transform rotate-90 w-4 h-5 text-white" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );

  // return (
  //   <div className="rounded-xl bg-gray-700 w-full px-4 my-4">
  //     {isReply ? <span>{subtitle}</span> : ''}
  //     <div className="py-4">
  //       <div className="flex-grow">
  //         <div className="relative w-full">
  //           <TextareaAutosize
  //             minRows={1}
  //             maxRows={3}
  //             value={text}
  //             onChange={(e) => setText(e.target.value)}
  //             className="flex w-full bg-gray-600 border border-gray-500 rounded-lg focus:outline-none focus:border-indigo-300 p-4"
  //           />
  //         </div>
  //       </div>
  //       <div className="flex mt-2">
  //         <button
  //           type="button"
  //           className=" flex flex-none items-center justify-center text-gray-200 hover:text-gray-300"
  //         >
  //           <svg
  //             className="w-6 h-6"
  //             fill="none"
  //             stroke="currentColor"
  //             viewBox="0 0 24 24"
  //             xmlns="http://www.w3.org/2000/svg"
  //           >
  //             <path
  //               strokeLinecap="round"
  //               strokeLinejoin="round"
  //               strokeWidth="2"
  //               d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  //             />
  //           </svg>
  //         </button>
  //         <div className="flex-grow"> </div>
  //         <button
  //           type="button"
  //           onClick={cancelHandler || clear}
  //           className="flex-none flex items-center justify-center bg-gray-600 hover:bg-indigo-600 rounded-lg text-white px-4 ml-2 py-2 flex-shrink-0"
  //         >
  //           <span>Cancel</span>
  //         </button>
  //         <button
  //           type="button"
  //           onClick={isReply ? () => postReply(commentId) : postComment}
  //           className="flex flex-none items-center justify-center bg-indigo-500 hover:bg-indigo-600 rounded-lg text-white px-4 ml-2 py-2 flex-shrink-0"
  //         >
  //           <span>Post</span>
  //         </button>
  //       </div>
  //     </div>
  //   </div>
  // );
};
